import Profile from '@/pages/profile/Profile'
import { RouteConfig } from 'react-router-config'

const routes = (isAuthenticated: boolean): RouteConfig[] => [
  {
    path: '/profile',
    render: isAuthenticated ? Profile : () => null,
  },
]

export default routes
